// @flow strict

import { featureIsEnabled } from '@ta/common.features';

type SupplierCategoryInput = 'OWNER' | 'STAFF' | 'TRAVELER';

export type MediaGroupInput =
  | 'ALL_INCLUDING_RESTRICTED'
  | 'ALL_UNRESTRICTED'
  | 'DEFAULT'
  | 'DEFAULT_INCLUDING_RESTRICTED'
  | 'MANAGEMENT'
  | 'STAFF'
  | 'TRAVELER';

export type MediaFilter = {|
  mediaGroup: MediaGroupInput,
  supplierCategories?: Array<SupplierCategoryInput>,
|};

/**
 * Defines a set of utility constants used to display restricted partner content
 * (i.e. BookingCom photos) and their attribution metadata in our React web components.
 * This module must be kept in sync with RestrictedPartnerMedia.java to avoid inconsistencies
 * between our Dust and React UIs.
 */

/**
 * Returns the media group of the photos that appear under the 'all' category for a given location.
 */
export const getMediaFilterToRetrieveAllPhotos = (): MediaFilter => ({
  mediaGroup: featureIsEnabled('bcom_partner_photos')
    ? 'ALL_INCLUDING_RESTRICTED'
    : 'ALL_UNRESTRICTED',
});

/**
 * Returns the media group of the photos that are part of the photo albums returned by default for any location.
 */
export const getMediaFilterToRetrieveDefaultPhotos = (): MediaFilter => ({
  mediaGroup: featureIsEnabled('bcom_partner_photos') ? 'DEFAULT_INCLUDING_RESTRICTED' : 'DEFAULT',
});
